import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";
const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: `1px solid ${teal}`,
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const TRANSACTION_TYPES = [
  ["All Purchase", "All Sell", "Div Payout"],
  ["Purchase", "Sell", "SIP", "STO"],
  ["STI", "Switch In", "Switch Out", "SWP", "Dividend Reinvest", "Bonus"],
];

export default function TransactionsView() {
  const [reportDateFrom, setReportDateFrom] = useState("09-02-2026");
  const [reportDateTo, setReportDateTo] = useState("16-02-2026");
  const [assetClass, setAssetClass] = useState("mutualFund");
  const [selectUser, setSelectUser] = useState("");
  const [fund, setFund] = useState("All");
  const [scheme, setScheme] = useState("");
  const [category, setCategory] = useState("All");
  const [subCategory, setSubCategory] = useState("All");
  const [arn, setArn] = useState("All");
  const [euin, setEuin] = useState("");
  const [rta, setRta] = useState("All");
  const [folio, setFolio] = useState("");
  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");
  const [createdDateFrom, setCreatedDateFrom] = useState("");
  const [createdDateTo, setCreatedDateTo] = useState("");
  const [viewType, setViewType] = useState("onScreen");

  const [txTypes, setTxTypes] = useState(() => {
    const all = TRANSACTION_TYPES.flat();
    return all.reduce((acc, key) => ({ ...acc, [key]: true }), {});
  });

  const toggleTxType = (key) => {
    setTxTypes((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleReportGo = (e) => {
    e.preventDefault();
    console.log("Report Configuration", { reportDateFrom, reportDateTo });
  };

  const handleApply = (e) => {
    e.preventDefault();
    console.log({
      reportDateFrom,
      reportDateTo,
      assetClass,
      selectUser,
      fund,
      scheme,
      category,
      subCategory,
      arn,
      euin,
      rta,
      folio,
      minAmount,
      maxAmount,
      createdDateFrom,
      createdDateTo,
      txTypes,
      viewType,
    });
  };

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Transactions View</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Transactions View
                </li>
              </ol>
            </nav>
          </div>

          {/* Report Configuration bar */}
          <div style={cardStyle}>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              {/* <div className="d-flex align-items-center gap-2">
                <span
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    background: "#e2e8f0",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#64748b",
                    fontSize: "14px",
                  }}
                  aria-hidden
                >
                  −
                </span>
                <span className="fw-semibold text-secondary">Report Configuration</span>
              </div> */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <span className="position-relative d-inline-block">
                  <input
                    type="text"
                    placeholder="DD-MM-YYYY"
                    value={reportDateFrom}
                    onChange={(e) => setReportDateFrom(e.target.value)}
                    style={{ ...inputStyle, paddingLeft: 36, width: 130 }}
                    maxLength={10}
                  />
                  <span
                    className="position-absolute"
                    style={{ left: 10, top: "50%", transform: "translateY(-50%)", color: "#64748b", pointerEvents: "none", fontSize: "14px" }}
                    aria-hidden
                  >
                    📅
                  </span>
                </span>
                <span style={{ color: "#64748b" }}>-</span>
                <span className="position-relative d-inline-block">
                  <input
                    type="text"
                    placeholder="DD-MM-YYYY"
                    value={reportDateTo}
                    onChange={(e) => setReportDateTo(e.target.value)}
                    style={{ ...inputStyle, paddingLeft: 36, width: 130 }}
                    maxLength={10}
                  />
                  <span
                    className="position-absolute"
                    style={{ left: 10, top: "50%", transform: "translateY(-50%)", color: "#64748b", pointerEvents: "none", fontSize: "14px" }}
                    aria-hidden
                  >
                    📅
                  </span>
                </span>
                <button
                  type="button"
                  onClick={handleReportGo}
                  style={{
                    background: teal,
                    color: "#fff",
                    border: "none",
                    padding: "8px 20px",
                    borderRadius: "6px",
                    fontWeight: 600,
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                >
                  Go
                </button>
              </div>
            </div>
          </div>

          {/* Main filter card */}
          <div style={cardStyle}>
            <form onSubmit={handleApply}>
              {/* Asset Class */}
              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">Assets Class :</label>
                <div className="d-flex flex-wrap gap-4">
                  {[
                    { value: "mutualFund", label: "Mutual Fund" },
                    { value: "shareBond", label: "Share & Bond" },
                    { value: "fixedDeposit", label: "Fixed Deposit" },
                    { value: "otherAssets", label: "Other Assets" },
                  ].map(({ value, label }) => (
                    <label key={value} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                      <input
                        type="radio"
                        name="assetClass"
                        checked={assetClass === value}
                        onChange={() => setAssetClass(value)}
                        style={{ accentColor: teal }}
                      />
                      {label}
                    </label>
                  ))}
                </div>
              </div>

              {/* Filter */}
              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">Filter:</label>
                <div className="row g-3">
                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary mb-1 d-block">Select User</label>
                    <span className="position-relative d-inline-block w-100">
                      <select
                        value={selectUser}
                        onChange={(e) => setSelectUser(e.target.value)}
                        style={{
                          ...inputStyle,
                          background: teal,
                          color: "#fff",
                          borderColor: teal,
                          paddingLeft: 36,
                          appearance: "auto",
                        }}
                      >
                        <option value="">Select User</option>
                      </select>
                      <span
                        className="position-absolute"
                        style={{ left: 10, top: "50%", transform: "translateY(-50%)", color: "rgba(255,255,255,0.9)", pointerEvents: "none" }}
                        aria-hidden
                      >
                        <i className="fa-solid fa-user" style={{ fontSize: "14px" }} />
                      </span>
                    </span>
                  </div>
                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary mb-1 d-block">Fund</label>
                    <select value={fund} onChange={(e) => setFund(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-4">
                    <label className="form-label small text-secondary mb-1 d-block">Scheme</label>
                    <input
                      type="text"
                      placeholder="Type to Search..."
                      value={scheme}
                      onChange={(e) => setScheme(e.target.value)}
                      style={inputStyle}
                    />
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Category</label>
                    <select value={category} onChange={(e) => setCategory(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Sub Category</label>
                    <select value={subCategory} onChange={(e) => setSubCategory(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">ARN</label>
                    <select value={arn} onChange={(e) => setArn(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">EUIN</label>
                    <input
                      type="text"
                      placeholder="Enter EUIN"
                      value={euin}
                      onChange={(e) => setEuin(e.target.value)}
                      style={inputStyle}
                    />
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">RTA</label>
                    <select value={rta} onChange={(e) => setRta(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Folio</label>
                    <input
                      type="text"
                      placeholder="Enter Folio"
                      value={folio}
                      onChange={(e) => setFolio(e.target.value)}
                      style={inputStyle}
                    />
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Amount</label>
                    <div className="d-flex gap-2">
                      <input
                        type="text"
                        placeholder="Minimum Amount"
                        value={minAmount}
                        onChange={(e) => setMinAmount(e.target.value)}
                        style={inputStyle}
                      />
                      <input
                        type="text"
                        placeholder="Maximum Amount"
                        value={maxAmount}
                        onChange={(e) => setMaxAmount(e.target.value)}
                        style={inputStyle}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Created Date</label>
                    <div className="d-flex align-items-center gap-2">
                      <span className="position-relative d-inline-block" style={{ flex: 1, minWidth: 0 }}>
                        <input
                          type="text"
                          placeholder="DD-MM-YYYY"
                          value={createdDateFrom}
                          onChange={(e) => setCreatedDateFrom(e.target.value)}
                          style={{ ...inputStyle, paddingLeft: 32 }}
                          maxLength={10}
                        />
                        <span
                          className="position-absolute"
                          style={{ left: 8, top: "50%", transform: "translateY(-50%)", color: "#64748b", pointerEvents: "none", fontSize: "12px" }}
                          aria-hidden
                        >
                          📅
                        </span>
                      </span>
                      <span style={{ color: "#64748b" }}>-</span>
                      <input
                        type="text"
                        placeholder="DD-MM-YYYY"
                        value={createdDateTo}
                        onChange={(e) => setCreatedDateTo(e.target.value)}
                        style={{ ...inputStyle, flex: 1, minWidth: 0 }}
                        maxLength={10}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Transaction Type */}
              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">Transaction Type</label>
                <div className="row g-2">
                  {TRANSACTION_TYPES.map((col, colIndex) => (
                    <div key={colIndex} className="col-12 col-md-4">
                      <div className="d-flex flex-column gap-2">
                        {col.map((key) => (
                          <label key={key} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                            <input
                              type="checkbox"
                              checked={txTypes[key] ?? false}
                              onChange={() => toggleTxType(key)}
                              style={{ accentColor: teal }}
                            />
                            {key}
                          </label>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* View Type */}
              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">View Type:</label>
                <div className="d-flex gap-4">
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input
                      type="radio"
                      name="viewType"
                      checked={viewType === "onScreen"}
                      onChange={() => setViewType("onScreen")}
                      style={{ accentColor: teal }}
                    />
                    On Screen
                  </label>
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input
                      type="radio"
                      name="viewType"
                      checked={viewType === "xls"}
                      onChange={() => setViewType("xls")}
                      style={{ accentColor: teal }}
                    />
                    XLS
                  </label>
                </div>
              </div>

              <div className="text-center mt-4">
                <button
                  type="submit"
                  style={{
                    background: teal,
                    color: "#fff",
                    border: "none",
                    padding: "10px 28px",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
